/**
 * description: ["everything's gone", 'lucky someone passed by and took pitty', 'dragged back to the last town'],
 */

const death = (onDone, step = 0) => ({
  title: 'end of the road',
  description: ['vision blurs. knees buckle.', 'darkness'],
  buttons: [
    {
      title: 'Fade',
      hotkey: 'f',
      enabled: () => true,
      execute: () => {
        onDone();
        // Action.js routes outcome.isDead to onDeath, which starts the run over. Without
        // this the modal merely closed and play continued at zero health.
        return { outcome: { isDead: true, step }, result: { message: null } };
      }
    }
  ]
});

export default death;
